import { axiosWithToken } from "./axiosService";

export const getStates = async () => {
    try {
        const response = await axiosWithToken().get(`api/state`);
        return response.data;
    } catch (err) {
        throw err;
    }
}
